<template>
    <div class="out-box-con" :style="{ background: currentBg}">
        <slot></slot>
    </div>
</template>
<script>
export default {
  props: {
    bg: {
      type: String,
      default: '#ffffff'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    currentBg () {
      return this.bg
    }
  }
}
</script>
<style lang="scss" scoped>
    .out-box-con{
        width: 100%;
        min-width: $main-width;
        // transition: background 0.5s;
    }
</style>
